module.exports = __webpack_public_path__ + "assets/lock.8634238d.svg";